import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import './Nav.css';

const Nav: React.FC = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const menuRef = useRef<HTMLUListElement | null>(null);
  const btnRef = useRef<HTMLButtonElement | null>(null);

  useEffect(() => {
    function onDocClick(e: MouseEvent) {
      if (!open) return;
      const target = e.target as Node;
      if (
        menuRef.current &&
        !menuRef.current.contains(target) &&
        btnRef.current &&
        !btnRef.current.contains(target)
      ) {
        setOpen(false);
      }
    }

    function onKey(e: KeyboardEvent) {
      if (e.key === 'Escape' && open) setOpen(false);
    }

    document.addEventListener('click', onDocClick);
    document.addEventListener('keydown', onKey);

    return () => {
      document.removeEventListener('click', onDocClick);
      document.removeEventListener('keydown', onKey);
    };
  }, [open]);

  useEffect(() => {
    if (open) {
      document.documentElement.classList.add('nav-open');
      document.body.style.overflow = 'hidden';
    } else {
      document.documentElement.classList.remove('nav-open');
      document.body.style.overflow = '';
    }
  }, [open]);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const onLinkClick = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    setOpen(false);
    const href = e.currentTarget.getAttribute('href');

    if (href && href.startsWith('#')) {
      const el = document.getElementById(href.slice(1));
      if (el) {
        e.preventDefault();
        const nav = document.querySelector('.nav.scrolled') as HTMLElement | null;
        const navHeight = nav ? nav.offsetHeight : 80;
        const rect = el.getBoundingClientRect();
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const top = rect.top + scrollTop - navHeight - 8;
        window.scrollTo({ top, behavior: 'smooth' });
      }
    }
  };

  return (
    <nav className={`nav site-nav ${scrolled ? 'scrolled' : ''}`} role="navigation" aria-label="Main">
      <div className="nav-inner">
        <div className="brand">
          <a href="/" aria-label="Succit home">
            <img
              className="brand-img"
              src={scrolled ? '/light-blue-logo.png' : '/white-logo.png'}
              alt="Succit logo"
            />
          </a>
        </div>

        <button
          ref={btnRef}
          className={`nav-toggle ${open ? 'open' : ''}`}
          aria-expanded={open}
          aria-controls="primary-navigation"
          aria-label={open ? 'Close menu' : 'Open menu'}
          onClick={() => setOpen((s) => !s)}
        >
          <span className="bar" />
          <span className="bar" />
          <span className="bar" />
        </button>

        <ul
          id="primary-navigation"
          ref={menuRef}
          className={`nav-links ${open ? 'open' : ''}`}
          role="menu"
        >
          <li role="none">
            <a role="menuitem" href="#why" onClick={onLinkClick} className="nav-link">
              Services
            </a>
          </li>
          <li role="none">
            <a role="menuitem" href="#contact" onClick={onLinkClick} className="nav-link">
              Contact
            </a>
          </li>
          {/* <li role="none">
            <Link role="menuitem" to="/sponsored" onClick={() => setOpen(false)} className="nav-link">
              Sponsored
            </Link>
          </li> */}
        </ul>
      </div>
    </nav>
  );
};

export default Nav;
